import React, { useState, useRef, useEffect } from 'react';
import styles from '../landing.module.scss';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import mainlogo from "../../../assets/images/new_web_logo.png";
import { Menu, X, ChevronDown } from 'lucide-react';
import GlobalSearchBar from '../../../components/Common/GlobalSearchBar';

// Login Redirect Utility
import { navigateToLogin } from '../../../utils/loginRedirect';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFeaturesDropdownOpen, setIsFeaturesDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const scrollToSection = (id) => {
    // If already on landing page
    if (location.pathname === '/') {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Navigate first, then scroll
      navigate(`/#${id}`);
    }

    setIsMenuOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFeaturesDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Public pages for features dropdown (only pages with auth: false)
  const publicPages = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/trending', label: 'Trending Apps' },
    { path: '/top-revenued', label: 'Top Revenue Apps' },
    { path: '/about-us', label: 'About Us' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contact-us', label: 'Contact Us' },
  ];

  return (
    <nav className={styles.navbar}>
      <div className={styles.container}>
        <div className={styles.navInner}>

          {/* Logo */}
          <Link to="/" className={styles.logo}>
            <img src={mainlogo} alt="KeyQuest" className={styles.logoImage} />
          </Link>

          {/* Search Bar - Desktop */}
          <div className={styles.searchContainer}>
            <GlobalSearchBar placeholder="Search apps, games..." />
          </div>

          <div className={styles.navLinks} />

          {/* Desktop */}
          <div className={styles.actions}>

            {/* Features Dropdown */}
            <div className={styles.featuresDropdown} ref={dropdownRef}>
              <button 
                onClick={() => setIsFeaturesDropdownOpen(!isFeaturesDropdownOpen)}
                className={`${styles.btn} ${styles.btnSecondary} ${styles.featuresToggle}`}
              >
                Features
                <ChevronDown size={16} className={`${styles.chevron} ${isFeaturesDropdownOpen ? styles.open : ''}`} />
              </button>
              
              {isFeaturesDropdownOpen && (
                <div className={styles.dropdownMenu}>
                  <div className={styles.dropdownGrid}>
                    {publicPages.map((page) => (
                      <Link
                        key={page.path}
                        to={page.path}
                        className={styles.dropdownItem}
                        onClick={() => {
                          setIsFeaturesDropdownOpen(false);
                          setIsMenuOpen(false);
                        }}
                      >
                        {page.label}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <button onClick={() => scrollToSection('how-it-works')} className={`${styles.btn} ${styles.btnSecondary}`}>
              How it works
            </button>

            <button onClick={() => scrollToSection('pricing')} className={`${styles.btn} ${styles.btnSecondary}`}>
              Pricing
            </button>

            {/* <button onClick={() => scrollToSection('case-studies')} className={`${styles.btn} ${styles.btnSecondary}`}>
              Blogs
            </button> */}
            <Link to="/blog" className={`${styles.btn} ${styles.btnSecondary}`}>
              Blog
            </Link>

            <Link to="/contact-us" className={`${styles.btn} ${styles.btnContactSales}`}>
              Contact Sales
            </Link>

            <button 
            onClick={() => navigateToLogin(location.pathname, navigate)}
            className={`${styles.btn} ${styles.btnPrimary}`}
          >
            Sign In
          </button>
          </div>

          {/* Mobile Toggle */}
          <button
            className={styles.mobileMenuBtn}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

        </div>
      </div>

      {/* Mobile Menu */}
          <div className={`${styles.mobileMenu} ${isMenuOpen ? styles.open : ''}`}>
            {/* Mobile Search */}
            <div className={styles.mobileSearch}>
              <GlobalSearchBar placeholder="Search apps, games..." />
            </div>
            
            <div className={styles.mobileActions}>
              {/* Mobile Features Dropdown */}
              <div className={styles.mobileFeaturesDropdown}>
                <button 
                  onClick={() => setIsFeaturesDropdownOpen(!isFeaturesDropdownOpen)}
                  className={`${styles.btn} ${styles.btnSecondary}`}
                >
                  Features
                  <ChevronDown size={16} className={`${styles.chevron} ${isFeaturesDropdownOpen ? styles.open : ''}`} />
                </button>
                
                {isFeaturesDropdownOpen && (
                  <div className={styles.mobileDropdownMenu}>
                    {publicPages.map((page) => (
                      <Link
                        key={page.path}
                        to={page.path}
                        className={styles.mobileDropdownItem}
                        onClick={() => {
                          setIsFeaturesDropdownOpen(false);
                          setIsMenuOpen(false);
                        }}
                      >
                        {page.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
              
              <button onClick={() => scrollToSection('how-it-works')} className={`${styles.btn} ${styles.btnSecondary}`}>How it works</button>
              <button onClick={() => scrollToSection('pricing')} className={`${styles.btn} ${styles.btnSecondary}`}>Pricing</button>
              <Link to="/blog" className={`${styles.btn} ${styles.btnSecondary}`}>
                Blogs
              </Link>
              <Link to="/contact-us" className={`${styles.btn} ${styles.btnSecondary}`}>
                Contact Us
              </Link>
              <Link to="/login" className={`${styles.btn} ${styles.btnPrimary}`}>Sign In</Link>
            </div>
          </div>
    </nav>
  );
};

export default Navbar;


// import React, { useState } from 'react';
// import styles from '../landing.module.scss';
// import { Link } from 'react-router-dom';
// import mainlogo from "../../../assets/images/new_web_logo.png";
// import { Menu, X } from 'lucide-react';

// const Navbar = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   return (
//     <nav className={styles.navbar}>
//       <div className={styles.container}>
//         <div className={styles.navInner}>

//           {/* Logo */}
//           <div className={styles.logo}>
//             <img src={mainlogo} alt="KeyQuest" className={styles.logoImage} />
//           </div>

//           {/* Center placeholder */}
//           <div className={styles.navLinks} />

//           {/* Desktop Actions */}
//           <div className={styles.actions}>
//             <Link to="/about" className={`${styles.btn} ${styles.btnSecondary}`}>About</Link>
//             <Link to="/features" className={`${styles.btn} ${styles.btnSecondary}`}>Features</Link>
//             <Link to="/pricing" className={`${styles.btn} ${styles.btnSecondary}`}>Pricing</Link>
//             <Link to="/blog" className={`${styles.btn} ${styles.btnSecondary}`}>Blog</Link>

//             <Link to="/register" className={`${styles.btn} ${styles.btnPrimary}`}>
//               Sign Up
//             </Link>
//           </div>

//           {/* Mobile Menu Button */}
//           <button
//             className={styles.mobileMenuBtn}
//             onClick={() => setIsMenuOpen(!isMenuOpen)}
//             aria-label="Toggle menu"
//           >
//             {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
//           </button>

//         </div>
//       </div>

//       {/* Mobile Menu */}
//       <div className={`${styles.mobileMenu} ${isMenuOpen ? styles.open : ''}`}>
//         <div className={styles.mobileActions}>
//           <Link to="/login" className={`${styles.btn} ${styles.btnPrimary}`}>Login</Link>
//           <Link to="/register" className={`${styles.btn} ${styles.btnPrimary}`}>Sign Up</Link>
//           <Link to="/blog" className={`${styles.btn} ${styles.btnSecondary}`}>Blog</Link>
//           <Link to="/about" className={`${styles.btn} ${styles.btnSecondary}`}>About</Link>
//           <Link to="/features" className={`${styles.btn} ${styles.btnSecondary}`}>Features</Link>
//           <Link to="/pricing" className={`${styles.btn} ${styles.btnSecondary}`}>Pricing</Link>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;

// import React, { useState } from 'react';
// import styles from '../landing.module.scss';
// import { Link } from 'react-router-dom';
// import mainlogo from "../../../assets/images/new_web_logo.png";
// import GlobalSearchBar from '../../../components/Common/GlobalSearchBar';
// import { Menu, X } from 'lucide-react';

// const Navbar = () => {
//     const [isMenuOpen, setIsMenuOpen] = useState(false);

//     return (
//         <nav className={styles.navbar}>
//             <div className={styles.container}>
//                 <div className={styles.navInner}>

//                     <div className={styles.logo}>
//                         <img src={mainlogo} alt="KeyQuest" className={styles.logoImage} />
//                     </div>

//                     <div className={styles.navLinks}>
//                         {/* <GlobalSearchBar style={{ maxWidth: '400px' }} /> */}
//                     </div>

//                     <div className={styles.actions}>
//                         <Link to="/about" className={`${styles.btn} ${styles.btnSecondary}`}>
//                             About   
//                         </Link>
//                         <Link to="/features" className={`${styles.btn} ${styles.btnSecondary}`}>
//                             Features
//                         </Link>
//                         <Link to="/pricing" className={`${styles.btn} ${styles.btnSecondary}`}>
//                             Pricing
//                         </Link>
//                         <Link to="/blog" className={`${styles.btn} ${styles.btnSecondary}`}>
//                             Blog
//                         </Link>
//                         {/* <Link to="/login" className={`${styles.btn} ${styles.btnPrimary}`}>
//                             Login
//                         </Link> */}
//                         <Link to="/register" className={`${styles.btn} ${styles.btnPrimary}`}>
//                             Sign Up
//                         </Link>
//                     </div>

//                     {/* Mobile Menu Button */}
//                     <button
//                         className={styles.mobileMenuBtn}
//                         onClick={() => setIsMenuOpen(!isMenuOpen)}
//                         aria-label="Toggle menu"
//                     >
//                         {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
//                     </button>

//                 </div>
//             </div>

//             {/* Mobile Menu Dropdown */}
//             <div className={`${styles.mobileMenu} ${isMenuOpen ? styles.open : ''}`}>
//                 <div className={styles.mobileSearch}>
//                     {/* <GlobalSearchBar style={{ maxWidth: '100%' }} /> */}
//                 </div>
//                 <div className={styles.mobileActions}>
//                     <Link to="/login" className={`${styles.btn} ${styles.btnPrimary}`}>
//                         Login
//                     </Link>
//                     <Link to="/register" className={`${styles.btn} ${styles.btnPrimary}`}>
//                         Sign Up
//                     </Link>
//                     <Link to="/blog" className={`${styles.btn} ${styles.btnSecondary}`}>
//                         Blog
//                     </Link>
//                     <Link to="/about" className={`${styles.btn} ${styles.btnSecondary}`}>
//                         About
//                     </Link>
//                     <Link to="/features" className={`${styles.btn} ${styles.btnSecondary}`}>
//                         Features
//                     </Link>
//                     <Link to="/pricing" className={`${styles.btn} ${styles.btnSecondary}`}>
//                         Pricing
//                     </Link>
//                 </div>
//             </div>
//         </nav>
//     );
// };

// export default Navbar;
